export enum AiAssistantValueType {
  SUBJECT = 'subject',
  HIDDEN_PREHEADER = 'hiddenPreheader',
  TEXT_BLOCK = 'textBlock',
}
